import {register} from '../vendor/theme-scripts/theme-sections';
import drawer from '../features/header-mobile-drawer';
import stickyHeader from '../features/header-sticky';
import hoverDisclosure from '../features/header-hover-disclosure';
import hoverUnderline from '../features/header-hover-underline';
import {readHeights} from '../globals/height';
import headerTotals from '../features/header-totals';
import searchPopdown from '../features/header-search-popdown';
import {swatchGridSection} from '../features/swatch';
import {cartDrawer} from '../features/cart-items';
import accordion from '../features/accordion';
import {searchResultsGlobal} from '../features/header-search-predictive';
import searchDrawer from '../features/header-search-drawer';
import popoutSection from '../features/popout';
import headerMobileSliderule from '../features/header-mobile-sliderule';
import cartPopdown from '../features/cart-popdown';

const selectors = {
  wrapper: '[data-header-wrapper]',
  style: 'data-header-style',
  widthContent: '[data-takes-space]',
  desktop: '[data-header-desktop]',
  cloneClass: 'js__header__clone',
  showMobileClass: 'js__show__mobile',
  backfill: '[data-header-backfill]',
  transparent: 'data-header-transparent',
  overrideBorder: 'header-override-border',
  firstSectionHasImage: '.main-content > .shopify-section:first-child [data-overlay-header]',
  preventTransparentHeader: '.main-content > .shopify-section:first-child [data-prevent-transparent-header]',
  deadLink: '.navlink[href="#"]',
};

let sections = {};

class Header {
  constructor(el) {
    this.wrapper = el;
    this.style = this.wrapper.dataset.style;
    this.desktop = this.wrapper.querySelector(selectors.desktop);
    this.transparent = this.wrapper.getAttribute(selectors.transparent) !== 'false';
    this.overlayedImages = document.querySelectorAll(selectors.firstSectionHasImage);
    this.deadLinks = document.querySelectorAll(selectors.deadLink);

    this.killDeadLinks();
    if (this.style !== 'drawer' && this.desktop) {
      this.minWidth = this.getMinWidth();
      this.listenWidth();
    }
    this.checkForImage();
    window.dispatchEvent(new Event('resize'));
    document.addEventListener('header:check', this.checkForImage.bind(this));

    // mobile menu ancher link click fix
    this.wrapper.querySelectorAll(`a.sliderow__title`).forEach((link, index) => {
      link.addEventListener(
        'click',
        function () {
          const href = link.getAttribute(`href`)
          if( href.indexOf( window.location.pathname ) !== -1 ) {
            document.querySelector(`.drawer__close`).click()
          }
        }.bind(this)
      );
    });
  }

  unload() {
    document.removeEventListener('theme:resize', this.checkWidth);
  }

  checkForImage() {
    this.overlayedImages = document.querySelectorAll(selectors.firstSectionHasImage);
    let preventTransparentHeader = document.querySelectorAll(selectors.preventTransparentHeader).length;

    if (this.overlayedImages.length && !preventTransparentHeader && this.transparent) {
      // is transparent and has image, overlay the image
      document.querySelector(selectors.backfill).style.display = 'none';
      this.listenOverlay();
    } else {
      this.wrapper.setAttribute(selectors.transparent, false);
    }

    if (this.overlayedImages.length && !preventTransparentHeader && !this.transparent) {
      // Have image but not transparent, remove border bottom
      this.wrapper.classList.add(selectors.overrideBorder);
      this.subtractHeaderHeight();
    }
  }

  listenOverlay() {
    document.addEventListener('theme:resize', this.checkWidth.bind(this));
    this.subtractAnnouncementHeight();
  }

  listenWidth() {
    document.addEventListener('theme:resize', this.checkWidth.bind(this));
    this.checkWidth();
  }

  killDeadLinks() {
    this.deadLinks.forEach((el) => {
      el.onclick = (e) => {
        e.preventDefault();
      };
    });
  }

  subtractAnnouncementHeight() {
    const {windowHeight, announcementHeight} = readHeights();
    this.overlayedImages.forEach((el) => {
      el.style.setProperty('--full-screen', `${windowHeight - announcementHeight}px`);
      el.classList.add('has-overlay');
    });
  }

  subtractHeaderHeight() {
    const {windowHeight, headerHeight} = readHeights();
    this.overlayedImages.forEach((el) => {
      el.style.setProperty('--full-screen', `${windowHeight - headerHeight}px`);
    });
  }

  checkWidth() {
    if (document.body.clientWidth < this.minWidth) {
      this.wrapper.classList.add(selectors.showMobileClass);
    } else {
      this.wrapper.classList.remove(selectors.showMobileClass);
    }
  }

  getMinWidth() {
    const comparitor = this.wrapper.cloneNode(true);
    comparitor.classList.add(selectors.cloneClass);
    document.body.appendChild(comparitor);
    const wideElements = comparitor.querySelectorAll(selectors.widthContent);
    let minWidth = 0;
    if (wideElements.length === 3) {
      minWidth = _sumSplitWidths(wideElements);
    } else {
      minWidth = _sumWidths(wideElements);
    }
    document.body.removeChild(comparitor);
    return minWidth + wideElements.length * 20;
  }
}

function _sumSplitWidths(nodes) {
  let arr = [];
  nodes.forEach((el) => {
    arr.push(el.clientWidth);
  });
  if (arr[0] > arr[2]) {
    arr[2] = arr[0];
  } else {
    arr[0] = arr[2];
  }
  const width = arr.reduce((a, b) => a + b);
  return width;
}
function _sumWidths(nodes) {
  let width = 0;
  nodes.forEach((el) => {
    width += el.clientWidth;
  });
  return width;
}

const header = {
  onLoad() {
    sections = new Header(this.container);
  },
  onUnload: function () {
    if (typeof sections.unload === 'function') {
      sections.unload();
    }
  },
};

register('header', [
  header,
  drawer,
  popoutSection,
  headerMobileSliderule,
  stickyHeader,
  hoverDisclosure,
  hoverUnderline,
  headerTotals,
  searchPopdown,
  searchResultsGlobal,
  searchDrawer,
  swatchGridSection,
  cartDrawer,
  cartPopdown,
  accordion,
]);
